export const braetlistellenData = [
  {
    x: 2587512.216797445,
    y: 1208944.6748708126,
    name: 'Aarberg - Wasserkraftwerk',
    url: 'http://braetlistellen.ch/aarberg-wasserkraftwerk/',
  },
  {
    x: 2620271.7725486113,
    y: 1213738.0175969552,
    name: 'Affoltern - Lueg',
    url: 'http://braetlistellen.ch/affoltern-lueg/',
  },
  {
    x: 2615727.302099112,
    y: 1197860.838965728,
    name: 'Arni - Rotiholz',
    url: 'http://braetlistellen.ch/arni-rotiholz/',
  },
  {
    x: 2610976.161707135,
    y: 1235687.039826403,
    name: 'Attiswil - H\u00f6chchr\u00fcz',
    url: 'http://braetlistellen.ch/attiswil-hoechchruez/',
  },
  {
    x: 2612180.727681006,
    y: 1235003.06873079,
    name: 'Attiswil - Reckenacher',
    url: 'http://braetlistellen.ch/attiswil-reckenacher/',
  },
  {
    x: 2586670.731441878,
    y: 1209370.8541793504,
    name: 'Bargen - Bargenschanze',
    url: 'http://braetlistellen.ch/bargen-bargenschanze/',
  },
  {
    x: 2586785.369852185,
    y: 1208493.444844199,
    name: 'Bargen - M\u00fclau',
    url: 'http://braetlistellen.ch/bargen-muelau/',
  },
  {
    x: 2607719.350266793,
    y: 1207555.8062961341,
    name: 'B\u00e4riswil - Chriegsholz',
    url: 'http://braetlistellen.ch/baeriswil-chriegsholz/',
  },
  {
    x: 2606523.604852164,
    y: 1190036.011294479,
    name: 'Belp - Belpberg',
    url: 'http://braetlistellen.ch/belp-belpberg/',
  },
  {
    x: 2603774.07819218,
    y: 1193837.7840422848,
    name: 'Belp - Cholholz',
    url: 'http://braetlistellen.ch/belp-cholholz/',
  },
  {
    x: 2600753.1596842073,
    y: 1200660.8641991783,
    name: 'Bern - Breitenrainpark',
    url: 'http://braetlistellen.ch/bern-breitenrainpark/',
  },
  {
    x: 2600515.1637487733,
    y: 1199316.0092116154,
    name: 'Bern - Dalmazibr\u00fccke',
    url: 'http://braetlistellen.ch/bern-dalmazibruecke/',
  },
  {
    x: 2600867.63493598,
    y: 1200702.4562624884,
    name: 'Bern - Johanneskirche',
    url: 'http://braetlistellen.ch/bern-johanneskirche/',
  },
  {
    x: 2599705.4539167276,
    y: 1199034.8535936135,
    name: 'Bern - Monbijoupark',
    url: 'http://braetlistellen.ch/bern-monbijoupark/',
  },
  {
    x: 2598785.36870522,
    y: 1200660.4082975872,
    name: 'Bern - Spielplatz Halen',
    url: 'http://braetlistellen.ch/bern-halen/',
  },
  {
    x: 2599779.2668716195,
    y: 1201296.3967557105,
    name: 'Bern - Studerstein',
    url: 'http://braetlistellen.ch/bern-studerstein/',
  },
  {
    x: 2596460.065888953,
    y: 1197410.1783601192,
    name: 'Bern - Taubentr\u00e4nke',
    url: 'https://braetlistellen.ch/bern-taubentraenke/',
  },
  {
    x: 2595212.852150817,
    y: 1199988.5527161895,
    name: 'Bern - Tierpark G\u00e4belbach',
    url: 'http://braetlistellen.ch/bern-gaebelbach/',
  },
  {
    x: 2598922.9942538496,
    y: 1200686.394188612,
    name: 'Bern - Tierspital',
    url: 'http://braetlistellen.ch/bern-tierspital/',
  },
  {
    x: 2605155.9555922244,
    y: 1176793.1041487078,
    name: 'Blumenstein - Schatth\u00fctte',
    url: 'https://braetlistellen.ch/blumenstein-schatthuette/',
  },
  {
    x: 2606812.5616197186,
    y: 1202964.2067323015,
    name: 'Bolligen - Bantiger',
    url: 'http://braetlistellen.ch/bolligen-bantiger/',
  },
  {
    x: 2607905.6940261675,
    y: 1202290.0650411958,
    name: 'Bolligen - Birchi, Ferenberg',
    url: 'http://braetlistellen.ch/bolligen-birchi/',
  },
  {
    x: 2603097.3873894727,
    y: 1204643.0789153578,
    name: 'Bolligen - Bottisacher',
    url: 'http://braetlistellen.ch/bolligen-bottisacher/',
  },
  {
    x: 2605662.037197806,
    y: 1202795.3714167713,
    name: 'Bolligen - Buechholz, Bantigen',
    url: 'http://braetlistellen.ch/bolligen-buechholz/',
  },
  {
    x: 2620007.226261353,
    y: 1193981.8430753066,
    name: 'Bowil - Sch\u00e4chli',
    url: 'https://braetlistellen.ch/bowil-schaechli/',
  },
  {
    x: 2587805.0268384074,
    y: 1219970.6178922632,
    name: 'Br\u00fcgg - Sandgrube',
    url: 'https://braetlistellen.ch/bruegg-sandgrube/',
  },
  {
    x: 2619214.147727117,
    y: 1184795.7495886353,
    name: 'Bucholterberg - Ch\u00fcestelli, Heimenschwand',
    url: 'https://braetlistellen.ch/bucholterberg-kuhstelle/',
  },
  {
    x: 2594829.945350083,
    y: 1220553.2854258714,
    name: 'B\u00fcren - Helvetiaplatz',
    url: 'http://braetlistellen.ch/bueren-helvetiaplatz/',
  },
  {
    x: 2615547.614327271,
    y: 1211829.5799717247,
    name: 'Burgdorf - Binzberg',
    url: 'http://braetlistellen.ch/burgdorf-binzberg/',
  },
  {
    x: 2614375.9706464303,
    y: 1212820.4306472037,
    name: 'Burgdorf - Gyrisberg',
    url: 'http://braetlistellen.ch/burgdorf-gyrisberg/',
  },
  {
    x: 2613498.2967454223,
    y: 1212786.2583099706,
    name: 'Burgdorf - Neumatt',
    url: 'https://braetlistellen.ch/burgdorf-neumatt/',
  },
  {
    x: 2613446.823435981,
    y: 1210607.2577106864,
    name: 'Burgdorf - Pleerwald (Pleeracher)',
    url: 'http://braetlistellen.ch/burgdorf-pleeracher/',
  },
  {
    x: 2612421.2296981392,
    y: 1210616.2721933064,
    name: 'Burgdorf - Pleerwald (Siebenwegeplatz)',
    url: 'http://braetlistellen.ch/burgdorf-siebenwegeplatz/',
  },
  {
    x: 2615580.745934341,
    y: 1213052.5747816027,
    name: 'Burgdorf - Sommerhaus',
    url: 'http://braetlistellen.ch/burgdorf-sommerhaus/',
  },
  {
    x: 2629081.284246967,
    y: 1189240.8952480222,
    name: 'Eggiwil - B\u00e4rbach',
    url: 'https://braetlistellen.ch/eggiwil-baerbach/',
  },
  {
    x: 2624461.891668214,
    y: 1192109.4692571247,
    name: 'Eggiwil - Junkholz',
    url: 'http://braetlistellen.ch/eggiwil-junkholz/',
  },
  {
    x: 2627109.81507211,
    y: 1195816.1817510286,
    name: 'Eggiwil - Scheidegg',
    url: 'http://braetlistellen.ch/eggiwil-scheidegg/',
  },
  {
    x: 2651180.5599607304,
    y: 1202816.7869715956,
    name: 'Entlebuch - Bohrplatte, Finsterwald',
    url: 'https://braetlistellen.ch/entlebuch-bohrplatte/',
  },
  {
    x: 2653169.87123091,
    y: 1199410.517572623,
    name: 'Entlebuch - Br\u00fcdern, Finsterwald',
    url: 'https://braetlistellen.ch/entlebuch-bruedern/',
  },
  {
    x: 2648981.9698904348,
    y: 1202710.528732163,
    name: 'Entlebuch - Tram, Finsterwald',
    url: 'http://braetlistellen.ch/entlebuch-tram/',
  },
  {
    x: 2651327.98122619,
    y: 1202477.4106840305,
    name: 'Entlebuch - Weiher, Finsterwald',
    url: 'http://braetlistellen.ch/entlebuch-weiher/',
  },
  {
    x: 2652348.705464583,
    y: 1202556.3077280873,
    name: 'Entlebuch - Wissenegg, Finsterwald',
    url: 'http://braetlistellen.ch/entlebuch-wissenegg/',
  },
  {
    x: 2630768.3398908176,
    y: 1213712.6120663842,
    name: 'Eriswil - Aeschigr\u00fcebli',
    url: 'http://braetlistellen.ch/eriswil-aeschigruebli/',
  },
  {
    x: 2632437.9209615784,
    y: 1211563.8830566143,
    name: 'Eriswil - Schwinger',
    url: 'http://braetlistellen.ch/eriswil-schwinger/',
  },
  {
    x: 2630884.29390855,
    y: 1212293.5096333558,
    name: 'Eriswil - Waldh\u00fctte Fritzenfluh',
    url: 'http://braetlistellen.ch/eriswil-waldhuette/',
  },
  {
    x: 2631522.058984953,
    y: 1214108.4368585967,
    name: 'Eriswil - W\u00fchre',
    url: 'http://braetlistellen.ch/eriswil-wuehre/',
  },
  {
    x: 2624214.482529081,
    y: 1181516.893507909,
    name: 'Eriz - Koppisbr\u00fcgg',
    url: 'http://braetlistellen.ch/eriz-koppisbruegg/',
  },
  {
    x: 2629100.108854524,
    y: 1181693.5581352485,
    name: 'Eriz - Moosboden',
    url: ' http://braetlistellen.ch/eriz-moosboden/',
  },
  {
    x: 2625601.8839360336,
    y: 1181633.3732409491,
    name: 'Eriz - Schachen',
    url: 'http://braetlistellen.ch/eriz-schachen/',
  },
  {
    x: 2630647.6632324588,
    y: 1181451.352860154,
    name: 'Eriz - Unterschwandegg',
    url: 'http://braetlistellen.ch/eriz-unterschwandegg/',
  },
  {
    x: 2638922.9320111345,
    y: 1196588.2860061629,
    name: 'Escholzmatt Marbach - B\u00fchlwald, Escholzmatt',
    url: 'http://braetlistellen.ch/escholzmatt-buehlwald/',
  },
  {
    x: 2637021.7545762756,
    y: 1195674.9474996272,
    name: 'Escholzmatt Marbach - Sankt Anna, Schwendelberg',
    url: 'http://braetlistellen.ch/escholzmatt-sanktanna/',
  },
  {
    x: 2635927.0119415894,
    y: 1192052.304559076,
    name: 'Escholzmatt Marbach - Schachenhus-Weiher, Wiggen',
    url: 'http://braetlistellen.ch/escholzmatt-schachenhus/',
  },
  {
    x: 2634491.861264253,
    y: 1188643.2569472287,
    name: 'Escholzmatt Marbach - St\u00e4ckis, Marbachegg',
    url: '',
  },
  {
    x: 2635450.5483178804,
    y: 1187043.101648414,
    name: 'Escholzmatt Marbach - Wald, Marbachegg',
    url: 'http://braetlistellen.ch/escholzmatt-wald/',
  },
  {
    x: 2635855.563428493,
    y: 1193646.854408072,
    name: 'Escholzmatt Marbach - Willis Tr\u00e4umli, Wiggen',
    url: 'https://braetlistellen.ch/escholzmatt-willi/',
  },
  {
    x: 2612753.3401873587,
    y: 1236056.4623945702,
    name: 'Farnern - Bettlerk\u00fcche',
    url: 'http://braetlistellen.ch/farnern-bettlerkueche/',
  },
  {
    x: 2593048.433992102,
    y: 1201025.0416744507,
    name: 'Frauenkappelen - Pfaffenried',
    url: 'http://braetlistellen.ch/frauenkappelen-pfaffenried/',
  },
  {
    x: 2615398.9872553386,
    y: 1190173.5738382982,
    name: 'Freimettigen - Hammersmatt',
    url: 'https://braetlistellen.ch/freimettigen-hammersmatt/',
  },
  {
    x: 2607551.440547354,
    y: 1188191.4683099082,
    name: 'Gerzensee - Waldh\u00fctte Halten',
    url: 'http://braetlistellen.ch/gerzensee-waldhuette/',
  },
  {
    x: 2632529.216590387,
    y: 1220147.7963009763,
    name: 'Gondiswil - Sagenwald',
    url: 'http://braetlistellen.ch/gondiswil-sagenwald/',
  },
  {
    x: 2621099.7197547173,
    y: 1230297.322546112,
    name: 'Graben - Sprenglinde',
    url: 'http://braetlistellen.ch/graben-sprenglinde/',
  },
  {
    x: 2594413.511679481,
    y: 1175624.5829533834,
    name: 'Guggisberg - Ottenleuebad',
    url: 'http://braetlistellen.ch/guggisberg-ottenleuebad/',
  },
  {
    x: 2607126.695680367,
    y: 1179934.0310067465,
    name: 'Gurzelen - Riedwald',
    url: 'https://braetlistellen.ch/gurzelen-riedwald/',
  },
  {
    x: 2613114.698933251,
    y: 1205763.2896422658,
    name: 'Hasle bei Burgdorf - K\u00fchberg Nord',
    url: 'http://braetlistellen.ch/hasle-kuehberg-nord/',
  },
  {
    x: 2612939.916086739,
    y: 1205276.0876482218,
    name: 'Hasle bei burgdorf - K\u00fchberg S\u00fcd',
    url: 'http://braetlistellen.ch/hasle-kuehberg-sued/',
  },
  {
    x: 2612597.8533788063,
    y: 1180380.4216057048,
    name: 'Heimberg - Zulgspitz',
    url: 'https://braetlistellen.ch/heimberg-zulgspitz/',
  },
  {
    x: 2615855.9829565864,
    y: 1210057.509796363,
    name: 'Heimiswil - Riedegg',
    url: 'http://braetlistellen.ch/heimiswil-riedegg/',
  },
  {
    x: 2618758.285573552,
    y: 1211994.8741139106,
    name: 'Heimiswil - Zeitlistal',
    url: 'https://braetlistellen.ch/heimiswil-zeitlistal/',
  },
  {
    x: 2621169.0211448716,
    y: 1228164.9571748883,
    name: 'Herzogenbuchsee - Chlausenh\u00fcsli',
    url: 'http://braetlistellen.ch/herzogenbuchsee-chlausenhuesli/',
  },
  {
    x: 2609170.3148394567,
    y: 1209340.2722323062,
    name: 'Hindelbank - Haselberg',
    url: 'http://braetlistellen.ch/hindelbank-haselberg/',
  },
  {
    x: 2629196.4710899675,
    y: 1217612.4119567208,
    name: 'Huttwil - Buebeglungge',
    url: 'http://braetlistellen.ch/huttwil-buebeglungge/',
  },
  {
    x: 2630730.007319357,
    y: 1216450.7699315918,
    name: 'Huttwil - Studerw\u00e4ldli-Chnubel',
    url: 'http://braetlistellen.ch/huttwil-studerwaeldli/',
  },
  {
    x: 2631321.633259899,
    y: 1218677.6954175471,
    name: 'Huttwil - Thomasboden',
    url: 'http://braetlistellen.ch/huttwil-thomasboden/',
  },
  {
    x: 2632013.450517445,
    y: 1219114.9560399377,
    name: 'Huttwil - Waldh\u00fctte H\u00fcbeliwald',
    url: 'http://braetlistellen.ch/huttwil-huebeliwald/',
  },
  {
    x: 2603032.404980703,
    y: 1203919.7642635833,
    name: 'Ittigen - Kappelisacker',
    url: 'http://braetlistellen.ch/ittigen-kappelisacker/',
  },
  {
    x: 2603766.89332313,
    y: 1203469.596139626,
    name: 'Ittigen - Mannenberg',
    url: 'http://braetlistellen.ch/ittigen-mannenberg/',
  },
  {
    x: 2602106.4311479176,
    y: 1203851.784369532,
    name: 'Ittigen - R\u00fctiw\u00e4ldli',
    url: 'http://braetlistellen.ch/ittigen-ruetiwaeldli/',
  },
  {
    x: 2585977.3356908076,
    y: 1207352.0026637618,
    name: 'Kallnach - Im Grien, Niederried',
    url: 'http://braetlistellen.ch/kallnach-grien/',
  },
  {
    x: 2584784.207261451,
    y: 1205741.3881151548,
    name: 'Kallnach - Stausee Niederried',
    url: 'http://braetlistellen.ch/kallnach-stausee-niederried/',
  },
  {
    x: 2601670.9521501344,
    y: 1194810.809835739,
    name: 'Kehrsatz - D\u00fcfti',
    url: 'http://braetlistellen.ch/kehrsatz-duefti/',
  },
  {
    x: 2611515.2446448063,
    y: 1183880.6109589618,
    name: 'Kiesen - Chisenwald',
    url: 'http://braetlistellen.ch/kiesen-chisenwald/',
  },
  {
    x: 2607069.4076966653,
    y: 1186073.8974120358,
    name: 'Kirchdorf - Eierhalte, M\u00fchledorf',
    url: 'http://braetlistellen.ch/kirchdorf-eierhalte/',
  },
  {
    x: 2605861.405512856,
    y: 1186192.5574276138,
    name: 'Kirchenthurnen - Moos',
    url: 'http://braetlistellen.ch/kirchenthurnen-moos/',
  },
  {
    x: 2598100.4114401718,
    y: 1203267.7801892054,
    name: 'Kirchlindach - H\u00f6he, Herrenschwanden',
    url: 'http://braetlistellen.ch/kirchlindach-hoehe/',
  },
  {
    x: 2597342.866668828,
    y: 1206151.4258920958,
    name: 'Kirchlindach - Leutschen',
    url: 'http://braetlistellen.ch/kirchlindach-leutschen/',
  },
  {
    x: 2597760.652335463,
    y: 1206297.3291478613,
    name: 'Kirchlindach - Wasserreservoir',
    url: 'http://braetlistellen.ch/kirchlindach-wasserreservoir/',
  },
  {
    x: 2592237.838484327,
    y: 1196505.852687753,
    name: 'K\u00f6niz - Bruucheren',
    url: 'http://braetlistellen.ch/koeniz-bruucheren/',
  },
  {
    x: 2597787.090572659,
    y: 1194302.4309841336,
    name: 'K\u00f6niz - Buechliholz, Gasel',
    url: 'http://braetlistellen.ch/koeniz-buechliholz/',
  },
  {
    x: 2597729.9960723906,
    y: 1195801.468428836,
    name: 'K\u00f6niz - B\u00fcschiacker, Schliern',
    url: 'http://braetlistellen.ch/koeniz-bueschiacker/',
  },
  {
    x: 2597947.145023605,
    y: 1193764.5325822658,
    name: 'K\u00f6niz - B\u00fcschiholz, Gasel',
    url: 'http://braetlistellen.ch/koeniz-bueschiholz/',
  },
  {
    x: 2594943.156241521,
    y: 1196997.512800114,
    name: 'K\u00f6niz - Erlen, Niederwangen',
    url: 'http://braetlistellen.ch/koeniz-erlen/',
  },
  {
    x: 2595831.3186420375,
    y: 1192826.609608875,
    name: 'K\u00f6niz - Friedhof, Niederscherli',
    url: 'http://braetlistellen.ch/koeniz-friedhof/',
  },
  {
    x: 2593585.709163845,
    y: 1196464.215274159,
    name: 'K\u00f6niz - Inselwald',
    url: 'http://braetlistellen.ch/koeniz-inselwald/',
  },
  {
    x: 2594162.423185364,
    y: 1193945.5050182277,
    name: 'K\u00f6niz - Reitiwald, Liebewil',
    url: 'http://braetlistellen.ch/koeniz-reitiwald/',
  },
  {
    x: 2593849.8599566035,
    y: 1195868.9514890804,
    name: 'K\u00f6niz - Ruine, Oberwangen',
    url: 'http://braetlistellen.ch/koeniz-ruine/',
  },
  {
    x: 2594333.499041858,
    y: 1197354.3684667281,
    name: 'K\u00f6niz - St\u00e4ge, Niederwangen',
    url: 'http://braetlistellen.ch/koeniz-staege/',
  },
  {
    x: 2599685.734028407,
    y: 1194327.6866437548,
    name: 'K\u00f6niz - Ulmizberg',
    url: 'http://braetlistellen.ch/koeniz-ulmizberg/',
  },
  {
    x: 2594566.71301524,
    y: 1195963.631619849,
    name: 'K\u00f6niz \u2013 Turnerspycher, Oberwangen',
    url: 'http://braetlistellen.ch/koeniz-turnerspycher/',
  },
  {
    x: 2592451.6574002095,
    y: 1195377.6436021947,
    name: 'K\u00f6niz, Dachseweid',
    url: 'http://braetlistellen.ch/koeniz-dachseweid/',
  },
  {
    x: 2612818.4209940596,
    y: 1192987.7771612725,
    name: 'Konolfingen - Ballenb\u00fchl',
    url: 'https://braetlistellen.ch/konolfingen-ballenbuehl/',
  },
  {
    x: 2619486.623017292,
    y: 1199083.7551815028,
    name: 'Landiswil - Hinteregg',
    url: 'http://braetlistellen.ch/landiswil-hinteregg/ ',
  },
  {
    x: 2627234.630163825,
    y: 1228313.6699812554,
    name: 'Langenthal - Moosrain',
    url: 'http://braetlistellen.ch/langenthal-moosrain/',
  },
  {
    x: 2627520.9446204593,
    y: 1229069.329290551,
    name: 'Langenthal - Tierpark',
    url: 'https://braetlistellen.ch/langenthal-tierpark/',
  },
  {
    x: 2630271.279378129,
    y: 1204056.5129818346,
    name: 'Langnau - Bluttenried',
    url: 'http://braetlistellen.ch/langnau-bluttenried/',
  },
  {
    x: 2625102.767968065,
    y: 1200517.7656662718,
    name: 'Langnau - D\u00fcrsr\u00fctiwald',
    url: 'https://braetlistellen.ch/langnau-duersruetiwald/',
  },
  {
    x: 2628297.054112126,
    y: 1203150.9037434752,
    name: 'Langnau - Egg',
    url: 'http://braetlistellen.ch/langnau-egg/',
  },
  {
    x: 2628083.7050554296,
    y: 1199210.73456925,
    name: 'Langnau - Giebel',
    url: 'http://braetlistellen.ch/langnau-giebel/',
  },
  {
    x: 2628606.0221808893,
    y: 1198108.9391993724,
    name: 'Langnau - Hapbachm\u00f6sli',
    url: 'https://braetlistellen.ch/langnau-hapbachmoesli/',
  },
  {
    x: 2628266.2550028968,
    y: 1197394.6040033742,
    name: 'Langnau - Ilfis, B\u00e4rau',
    url: 'http://braetlistellen.ch/langnau-ilfis/',
  },
  {
    x: 2628949.527015239,
    y: 1205471.6463157828,
    name: 'Langnau - Rafr\u00fcti',
    url: 'http://braetlistellen.ch/langnau-rafrueti/',
  },
  {
    x: 2631091.044009529,
    y: 1198660.0720395488,
    name: 'Langnau - Riegenen',
    url: 'http://braetlistellen.ch/langnau-riegenen/',
  },
  {
    x: 2630148.3755561574,
    y: 1205678.4623788658,
    name: 'Langnau - Rislau',
    url: 'http://braetlistellen.ch/langnau-rislau/',
  },
  {
    x: 2626702.359034191,
    y: 1199394.1824754165,
    name: 'Langnau - Sch\u00fctzengraben',
    url: 'http://braetlistellen.ch/langnau-schuetzengraben/',
  },
  {
    x: 2623708.6236908883,
    y: 1200016.700410485,
    name: 'Lauperswil - Eisenbahnbr\u00fccke, Emmenmatt',
    url: 'https://braetlistellen.ch/lauperswil-eisenbahnbruecke/',
  },
  {
    x: 2626284.197204659,
    y: 1202086.583579161,
    name: 'Lauperswil - Lihnen',
    url: 'https://braetlistellen.ch/lauperswil-lihnen/',
  },
  {
    x: 2624369.3059958788,
    y: 1200041.254210137,
    name: 'Lauperswil - Ober Ebenl\u00e4ng',
    url: 'http://braetlistellen.ch/lauperswil-ebenlaeng/',
  },
  {
    x: 2622376.3362513967,
    y: 1202254.2401077903,
    name: 'Lauperswil - Ruine Wartenstein',
    url: 'http://braetlistellen.ch/lauperswil-ruine/',
  },
  {
    x: 2618733.4701584643,
    y: 1189933.6988394598,
    name: 'Linden - Aebersold',
    url: 'http://braetlistellen.ch/linden-aebersold/',
  },
  {
    x: 2637068.1186175947,
    y: 1212226.4277813346,
    name: 'Luthern - Churzhubelegg',
    url: 'https://braetlistellen.ch/luthern-churzhubelegg/',
  },
  {
    x: 2637353.3724024077,
    y: 1208258.5975452417,
    name: 'Luthern - Luthern Bad',
    url: 'https://braetlistellen.ch/luthern-luthernbad/',
  },
  {
    x: 2636771.537941373,
    y: 1211323.296623338,
    name: 'Luthern - Lutrun',
    url: 'https://braetlistellen.ch/luthern-lutrun/',
  },
  {
    x: 2619406.3351992927,
    y: 1205365.4754599028,
    name: 'L\u00fctzelfl\u00fch - Gohlhausbr\u00fccke',
    url: 'http://braetlistellen.ch/luetzelflueh-gohlhausbruecke/',
  },
  {
    x: 2591319.542968688,
    y: 1214239.377887132,
    name: 'Lyss - Dreihubelwald',
    url: 'http://braetlistellen.ch/lyss-dreihubelwald/',
  },
  {
    x: 2589942.942988175,
    y: 1214490.145100701,
    name: 'Lyss - Guisanblick',
    url: 'https://braetlistellen.ch/lyss-guisanblick/',
  },
  {
    x: 2590965.389021941,
    y: 1214421.9003442791,
    name: 'Lyss - Waldhaus',
    url: 'http://braetlistellen.ch/lyss-waldhaus/',
  },
  {
    x: 2627915.20755774,
    y: 1224972.7102106535,
    name: 'Madiswil - Fiechtimoos',
    url: 'http://braetlistellen.ch/madiswil-fiechtimoos/',
  },
  {
    x: 2628323.080909418,
    y: 1225159.8561829685,
    name: 'Madiswil - Waldh\u00fctte Batzm\u00f6\u00f6sli',
    url: 'http://braetlistellen.ch/madiswil-batzmoesli/',
  },
  {
    x: 2628892.162133413,
    y: 1224456.390715018,
    name: 'Madiswil - Waldh\u00fctte Steinbruch',
    url: 'http://braetlistellen.ch/madiswil-steinbruch/',
  },
  {
    x: 2627826.770740424,
    y: 1224803.418490926,
    name: 'Madiswil - Zielacker',
    url: 'http://braetlistellen.ch/madiswil-zielacker/',
  },
  {
    x: 2607057.208703205,
    y: 1206321.6502870733,
    name: 'Mattstetten - Wannental',
    url: 'http://braetlistellen.ch/mattstetten-wannental/',
  },
  {
    x: 2594288.6727447086,
    y: 1207121.025361498,
    name: 'Meikirch - Buechwald',
    url: 'http://braetlistellen.ch/meikirch-buechwald/',
  },
  {
    x: 2593871.166787363,
    y: 1206539.5704168621,
    name: 'Meikirch - Chiuchwegwald',
    url: 'http://braetlistellen.ch/meikirch-chiuchwegwald/',
  },
  {
    x: 2632205.0878529046,
    y: 1224359.642134487,
    name: 'Melchnau - Babeliplatz',
    url: 'http://braetlistellen.ch/melchnau-babeliplatz/',
  },
  {
    x: 2631777.0361750247,
    y: 1225422.980102953,
    name: 'Melchnau - Burgruine Gr\u00fcnenberg',
    url: 'http://braetlistellen.ch/melchnau-burgruine/',
  },
  {
    x: 2629975.321592689,
    y: 1224747.1331593555,
    name: 'Melchnau - Pauli',
    url: 'http://braetlistellen.ch/melchnau-pauli/',
  },
  {
    x: 2572708.5487534557,
    y: 1200716.445273119,
    name: "Mont-Vully - Place de l'Antenne",
    url: 'http://braetlistellen.ch/mont-vully/',
  },
  {
    x: 2582118.537307252,
    y: 1215223.3367632793,
    name: 'M\u00f6rigen - Hafen',
    url: 'http://braetlistellen.ch/moerigen-hafen/',
  },
  {
    x: 2589730.16809629,
    y: 1201265.1080895632,
    name: 'M\u00fchleberg - Rappenried',
    url: 'http://braetlistellen.ch/muehleberg-rappenried/',
  },
  {
    x: 2588223.564723638,
    y: 1202068.009106276,
    name: 'M\u00fchleberg - Wasserkraftwerk',
    url: 'http://braetlistellen.ch/muehleberg-wasserkraftwerk/',
  },
  {
    x: 2604951.70758617,
    y: 1184724.5439803503,
    name: 'M\u00fchlethurnen - Graben',
    url: 'http://braetlistellen.ch/muehlethurnen-graben/',
  },
  {
    x: 2605916.713373272,
    y: 1184719.739122225,
    name: 'M\u00fchlethurnen \u2013 G\u00fcrbebadi',
    url: 'http://braetlistellen.ch/muehlethurnen-guerbebadi/',
  },
  {
    x: 2601213.889251438,
    y: 1206279.091537268,
    name: 'M\u00fcnchenbuchsee - Buchsiwald',
    url: 'https://braetlistellen.ch/muenchenbuchsee-buchsiwald/',
  },
  {
    x: 2609427.9036070923,
    y: 1193174.0528735972,
    name: 'M\u00fcnsingen - Schwand',
    url: 'http://braetlistellen.ch/muensingen-schwand/',
  },
  {
    x: 2610426.473175578,
    y: 1190696.3954878503,
    name: 'M\u00fcnsingen - Utteloo',
    url: 'http://braetlistellen.ch/muensingen-utteloo/',
  },
  {
    x: 2605003.7455946007,
    y: 1198506.706734197,
    name: 'Muri - Grossholz, G\u00fcmligen',
    url: 'http://braetlistellen.ch/muri-grossholz/',
  },
  {
    x: 2606096.963159611,
    y: 1198579.6372059495,
    name: 'Muri - Guisan-Denkmal, G\u00fcmligenberg',
    url: 'http://braetlistellen.ch/muri-denkmal/',
  },
  {
    x: 2604775.827481435,
    y: 1198720.192608684,
    name: 'Muri - Ostermundigenwald',
    url: 'http://braetlistellen.ch/muri-ostermundigenwald/',
  },
  {
    x: 2605908.6338071614,
    y: 1197358.5761847473,
    name: 'Muri - Tannacker, G\u00fcmligen',
    url: 'http://braetlistellen.ch/muri-tannacker/',
  },
  {
    x: 2593110.5425386718,
    y: 1193186.0146193365,
    name: 'Neuenegg - Au, Th\u00f6rishaus',
    url: 'http://braetlistellen.ch/neuenegg-au/',
  },
  {
    x: 2616821.6119011594,
    y: 1189604.2001011476,
    name: 'Niederh\u00fcnigen - Hirzebr\u00fcnnli',
    url: 'http://braetlistellen.ch/niederhuenigen-hirzebruennli/',
  },
  {
    x: 2616229.7190291435,
    y: 1190016.1218393226,
    name: 'Niederh\u00fcnigen - Paradiesli',
    url: 'http://braetlistellen.ch/niederhuenigen-paradiesli/',
  },
  {
    x: 2603196.2047835505,
    y: 1190364.519665419,
    name: 'Niedermuhlern - Fallenbach',
    url: 'http://braetlistellen.ch/niedermuhlern-fallenbach/',
  },
  {
    x: 2614777.726574393,
    y: 1209839.5202772575,
    name: 'Oberburg - Sportplatz',
    url: 'http://braetlistellen.ch/oberburg-sportplatz/',
  },
  {
    x: 2617410.265589343,
    y: 1190573.9431235504,
    name: 'Oberh\u00fcnigen - Tanzplatz',
    url: 'http://braetlistellen.ch/oberhuenigen-tanzplatz/',
  },
  {
    x: 2616384.3409037106,
    y: 1196026.503588518,
    name: 'Oberthal - Bauplatz',
    url: 'http://braetlistellen.ch/oberthal-bauplatz/',
  },
  {
    x: 2621830.690032709,
    y: 1220400.5501215176,
    name: 'Ochlenberg - Wanntalh\u00f6chi',
    url: 'http://braetlistellen.ch/ochlenberg-wanntalhoechi/',
  },
  {
    x: 2604477.1953003346,
    y: 1199960.8517864584,
    name: 'Ostermundigen - Buchbodenweg',
    url: 'https://braetlistellen.ch/ostermundigen-buchbodenweg/',
  },
  {
    x: 2604735.370613976,
    y: 1199337.3801383248,
    name: 'Ostermundigen - Ostermundigenberg',
    url: 'http://braetlistellen.ch/ostermundigen-ostermundigenberg/',
  },
  {
    x: 2605085.4293026202,
    y: 1200434.1411804135,
    name: 'Ostermundigen - R\u00fcti',
    url: 'https://braetlistellen.ch/ostermundigen-rueti/',
  },
  {
    x: 2604193.825862151,
    y: 1199889.0554121595,
    name: 'Ostermundigen - Steinbr\u00fcche',
    url: 'https://braetlistellen.ch/ostermundigen-steinbruch/ ',
  },
  {
    x: 2586026.418196659,
    y: 1207595.465640512,
    name: 'Radelfingen - Sportplatz',
    url: 'http://braetlistellen.ch/radelfingen-sportplatz/',
  },
  {
    x: 2587580.5455579995,
    y: 1202625.1778192173,
    name: 'Radelfingen - Thalmatt',
    url: 'http://braetlistellen.ch/radelfingen-thalmatt/',
  },
  {
    x: 2629939.3099452346,
    y: 1223992.8370505054,
    name: 'Reisiswil - Hochwacht',
    url: 'http://braetlistellen.ch/reisiswil-hochwacht/',
  },
  {
    x: 2630888.4606861835,
    y: 1222673.8964167077,
    name: 'Reisiswil - Schmidwald',
    url: 'http://braetlistellen.ch/reisiswil-schmidwald/',
  },
  {
    x: 2603545.288118764,
    y: 1185082.6364489708,
    name: 'Riggisberg - Eyw\u00e4ldli',
    url: 'http://braetlistellen.ch/riggisberg-eywaeldli/',
  },
  {
    x: 2628047.797887392,
    y: 1217312.3974265666,
    name: 'Rohrbachgraben - Chalteneggwald',
    url: 'http://braetlistellen.ch/rohrbachgraben-chalteneggwald/',
  },
  {
    x: 2643963.8071616422,
    y: 1206763.8355755224,
    name: 'Romoos - Zyberliland Haselschule',
    url: 'https://braetlistellen.ch/romoos-haselschule/',
  },
  {
    x: 2643610.6099948105,
    y: 1206541.5641417282,
    name: 'Romoos - Zyberliland N\u00fc\u00fctelimine',
    url: 'https://braetlistellen.ch/romoos-wasserspielplatz/',
  },
  {
    x: 2644338.2995063104,
    y: 1206541.6973630902,
    name: 'Romoos - Zyberliland Talherrenburg',
    url: 'https://braetlistellen.ch/romoos-talherrenburg/',
  },
  {
    x: 2621314.5952638085,
    y: 1190867.0237640515,
    name: 'R\u00f6thenbach - Chuderh\u00fcsi',
    url: 'http://braetlistellen.ch/roethenbach-chuderhuesi/',
  },
  {
    x: 2607529.0308395224,
    y: 1195327.7436123765,
    name: 'Rubigen - Kiesgrube',
    url: 'http://braetlistellen.ch/rubigen-kiesgrube/',
  },
  {
    x: 2608260.304248368,
    y: 1194962.840678707,
    name: 'Rubigen - Schattholz',
    url: 'http://braetlistellen.ch/rubigen-schattholz/',
  },
  {
    x: 2624630.8920860942,
    y: 1203957.359340127,
    name: 'R\u00fcderswil - Glattenwasen',
    url: 'https://braetlistellen.ch/ruederswil-glattenwasen/',
  },
  {
    x: 2625175.1049755146,
    y: 1204382.7473619939,
    name: 'R\u00fcderswil - Lehnegg',
    url: 'https://braetlistellen.ch/ruederswil-lehnegg/',
  },
  {
    x: 2622522.1985040945,
    y: 1203088.1325324068,
    name: 'R\u00fcderswil - Schinterschachen',
    url: 'http://braetlistellen.ch/ruederswil-schinterschachen/',
  },
  {
    x: 2619849.761718878,
    y: 1202771.061325218,
    name: 'R\u00fcderswil - Sch\u00f6nholz',
    url: 'http://braetlistellen.ch/ruederswil-schoenholz/',
  },
  {
    x: 2610290.8326869523,
    y: 1214951.556689139,
    name: 'R\u00fcdtligen-Alchenfl\u00fch - Autobahn\u00fcberdeckung',
    url: 'https://braetlistellen.ch/ruedtligen-autobahn/',
  },
  {
    x: 2610454.873730946,
    y: 1215244.6724811033,
    name: 'R\u00fcdtligen-Alchenfl\u00fch - Dammweg',
    url: 'https://braetlistellen.ch/ruedtligen-dammweg/',
  },
  {
    x: 2601336.8780495743,
    y: 1186025.0269470073,
    name: 'R\u00fceggisberg - Thanwald',
    url: 'http://braetlistellen.ch/rueggisberg-thanwald/',
  },
  {
    x: 2617801.7613602993,
    y: 1208015.5098538059,
    name: 'R\u00fcegsau - Zantihanser',
    url: 'http://braetlistellen.ch/ruegsau-zantihanser/',
  },
  {
    x: 2603197.867052107,
    y: 1186015.3711180668,
    name: 'R\u00fcmligen - Chatzenloch',
    url: 'http://braetlistellen.ch/ruemligen-chatzenloch/',
  },
  {
    x: 2597576.9113251637,
    y: 1182364.862634478,
    name: 'R\u00fcschegg - R\u00fctipl\u00f6tsch',
    url: 'http://braetlistellen.ch/rueschegg-ruetiploetsch/',
  },
  {
    x: 2636539.380070873,
    y: 1184570.2033089108,
    name: 'Schangnau - Bumb\u00e4chli',
    url: 'http://braetlistellen.ch/schangnau-bumbaechli/',
  },
  {
    x: 2631945.902882188,
    y: 1186474.218693357,
    name: 'Schangnau - Gl\u00fcckeli',
    url: 'http://braetlistellen.ch/schangnau-glueckeli/',
  },
  {
    x: 2639366.4992628475,
    y: 1182394.2594910958,
    name: 'Schangnau - Hinter Sch\u00f6nisei',
    url: 'http://braetlistellen.ch/schangnau-schoenisei/',
  },
  {
    x: 2632094.590813705,
    y: 1185623.004774883,
    name: 'Schangnau - M\u00fchlebr\u00fccke',
    url: 'http://braetlistellen.ch/schangnau-muehlebruecke/',
  },
  {
    x: 2612707.7106069755,
    y: 1194666.6532425096,
    name: 'Schlosswil - Buchens\u00e4li',
    url: 'http://braetlistellen.ch/schlosswil-buchensaeli/',
  },
  {
    x: 2594082.442511139,
    y: 1210123.7737953688,
    name: 'Sch\u00fcpfen - Waldhaus B\u00fcrglen',
    url: 'http://braetlistellen.ch/schuepfen-waldhaus/',
  },
  {
    x: 2643540.787926765,
    y: 1199985.6644894513,
    name: 'Sch\u00fcpfheim - Sagew\u00e4ldli',
    url: 'http://braetlistellen.ch/schuepfheim-sagewaeldli/',
  },
  {
    x: 2593255.8951166677,
    y: 1184902.8612428352,
    name: 'Schwarzenburg - Fl\u00fcehli',
    url: 'http://braetlistellen.ch/schwarzenburg-fluehli/',
  },
  {
    x: 2590468.595846203,
    y: 1183102.6441179544,
    name: 'Schwarzenburg - Tannligarten',
    url: 'http://braetlistellen.ch/schwarzenburg-tannligarten/',
  },
  {
    x: 2593543.229785636,
    y: 1186366.7422768923,
    name: 'Schwarzenburg - Tannzapfenhubel, Wahlern',
    url: '',
  },
  {
    x: 2591558.0953329876,
    y: 1188376.7258025676,
    name: 'Schwarzenburg - Waldhaus Albligen',
    url: 'http://braetlistellen.ch/schwarzenburg-waldhaus/',
  },
  {
    x: 2620230.19032263,
    y: 1220002.1278691068,
    name: 'Seeberg - Mutzgraben',
    url: 'https://braetlistellen.ch/seeberg-mutzgraben/',
  },
  {
    x: 2591726.175030716,
    y: 1207314.3890759572,
    name: 'Seedorf - Chutzenh\u00fctte',
    url: 'http://braetlistellen.ch/seedorf-chutzen/',
  },
  {
    x: 2608829.282350893,
    y: 1181479.5128669771,
    name: 'Seftigen - Fronholzwald',
    url: 'https://braetlistellen.ch/seftigen-fronholzwald/',
  },
  {
    x: 2623805.5435671206,
    y: 1193517.023646933,
    name: 'Signau - Kreuzacker',
    url: 'http://braetlistellen.ch/signau-kreuzacker/',
  },
  {
    x: 2620219.5988749946,
    y: 1173986.2602554157,
    name: 'Sigriswil - Riedli bei Gunten',
    url: 'http://braetlistellen.ch/sigriswil-riedli/',
  },
  {
    x: 2615216.073285151,
    y: 1174322.7096330277,
    name: 'Spiez - Seewiese Einigen',
    url: 'https://braetlistellen.ch/spiez-seewiese/',
  },
  {
    x: 2606087.5648580557,
    y: 1200576.142957396,
    name: 'Stettlen - Worble',
    url: 'http://braetlistellen.ch/stettlen-worble/',
  },
  {
    x: 2588723.8691468583,
    y: 1217722.7306504583,
    name: 'Studen - Petinesca',
    url: 'https://braetlistellen.ch/studen-petinesca/',
  },
  {
    x: 2632106.093608048,
    y: 1207962.3806715494,
    name: 'Sumiswald - Arnigr\u00fcebli',
    url: 'http://braetlistellen.ch/sumiswald-arnigruebli/',
  },
  {
    x: 2624810.8466259846,
    y: 1210142.768336067,
    name: 'Sumiswald - Kleineggblick',
    url: 'https://braetlistellen.ch/sumiswald-kleineggblick/',
  },
  {
    x: 2634141.9278533272,
    y: 1207165.990735524,
    name: 'Sumiswald - Riedbad',
    url: 'https://braetlistellen.ch/sumiswald-riedbad/',
  },
  {
    x: 2624975.9248957043,
    y: 1208102.9790342136,
    name: 'Sumiswald - Steinweid',
    url: 'http://braetlistellen.ch/sumiswald-steinweid/',
  },
  {
    x: 2630332.062001539,
    y: 1208192.8009830317,
    name: 'Sumiswald - Vorderarni',
    url: 'https://braetlistellen.ch/sumiswald-vorderarni/',
  },
  {
    x: 2614863.805992263,
    y: 1176291.719774685,
    name: 'Thun Grunderinseli',
    url: 'http://braetlistellen.ch/thun-grunderinseli/',
  },
  {
    x: 2622698.407631567,
    y: 1230010.6892166652,
    name: 'Thunstetten - Ischlegli, B\u00fctzberg',
    url: 'http://braetlistellen.ch/thunstetten-ischlegli/',
  },
  {
    x: 2625486.722443659,
    y: 1206142.8193239884,
    name: 'Trachselwald - Schwarzenegg',
    url: 'http://braetlistellen.ch/trachselwald-schwarzenegg/',
  },
  {
    x: 2634360.968902515,
    y: 1200022.5885203052,
    name: 'Trub - Freizeitplatz Ried',
    url: 'http://braetlistellen.ch/trub-ried/',
  },
  {
    x: 2632960.6299913083,
    y: 1197693.8766990365,
    name: 'Trub - Risisegg',
    url: 'http://braetlistellen.ch/trub-risisegg/',
  },
  {
    x: 2633101.9229653915,
    y: 1200070.9632444393,
    name: 'Trub - Seltenbach',
    url: 'https://braetlistellen.ch/trub-seltenbach/',
  },
  {
    x: 2633713.777231517,
    y: 1198892.5067783508,
    name: 'Trub - Stampfeli',
    url: 'http://braetlistellen.ch/trub-stampfeli/',
  },
  {
    x: 2633126.7781352215,
    y: 1201039.9694751515,
    name: 'Trub - Unter Stauffen',
    url: 'https://braetlistellen.ch/trub-unterstauffen/',
  },
  {
    x: 2630821.9456087598,
    y: 1197019.006493863,
    name: 'Trubschachen - Dorfschulhaus',
    url: 'http://braetlistellen.ch/trubschachen-dorfschulhaus/',
  },
  {
    x: 2630662.091177548,
    y: 1197714.2317481872,
    name: 'Trubschachen - Folzh\u00f6he',
    url: 'http://braetlistellen.ch/trubschachen-folzhoehe/',
  },
  {
    x: 2629090.8294505742,
    y: 1195188.2442122146,
    name: 'Trubschachen - Hegenwald',
    url: 'https://braetlistellen.ch/trubschachen-hegenwald/',
  },
  {
    x: 2631101.459082035,
    y: 1196655.586861785,
    name: 'Trubschachen - Ilfisbadi',
    url: 'http://braetlistellen.ch/trubschachen-ilfisbadi/',
  },
  {
    x: 2578217.0266701016,
    y: 1215653.7306786387,
    name: 'Twann T\u00fcscherz - Kleintwann',
    url: 'http://braetlistellen.ch/twann-kleintwann/',
  },
  {
    x: 2611036.8841642966,
    y: 1180331.1139831773,
    name: 'Uetendorf - Gl\u00fctsch',
    url: 'http://braetlistellen.ch/uetendorf-gluetsch/',
  },
  {
    x: 2610031.6104044984,
    y: 1202839.3087421933,
    name: 'Vechigen - Br\u00fc\u00fcsch, Utzigen',
    url: 'http://braetlistellen.ch/vechigen-bruesch/',
  },
  {
    x: 2609328.3677043505,
    y: 1199907.8164220767,
    name: 'Vechigen - Dachsh\u00f6lzli, Vechigen Dorf',
    url: 'http://braetlistellen.ch/vechigen-dachshoelzli/',
  },
  {
    x: 2606660.1545935296,
    y: 1199036.2539728095,
    name: 'Vechigen - Gheiholz, Dentenberg',
    url: 'http://braetlistellen.ch/vechigen-gheiholz/',
  },
  {
    x: 2612058.5955160796,
    y: 1201198.9241513833,
    name: 'Vechigen - M\u00e4nziwilegg',
    url: 'http://braetlistellen.ch/vechigen-maenziwilegg/',
  },
  {
    x: 2610457.0629821355,
    y: 1200852.4034573254,
    name: 'Vechigen - Stockmatt, Utzigen',
    url: 'http://braetlistellen.ch/vechigen-stockmatt/',
  },
  {
    x: 2607217.64814308,
    y: 1198711.1652820816,
    name: 'Vechigen - Wysseche, Dentenberg',
    url: 'http://braetlistellen.ch/vechigen-wysseche/',
  },
  {
    x: 2612314.1726946407,
    y: 1198825.2754245894,
    name: 'Walkringen - R\u00fcttihubelbad',
    url: 'http://braetlistellen.ch/walkringen-ruettihubelbad/',
  },
  {
    x: 2616317.058847301,
    y: 1231806.6734907017,
    name: 'Wangen an der Aare - Schloss',
    url: 'http://braetlistellen.ch/wangen-schloss/',
  },
  {
    x: 2604256.5802919,
    y: 1180788.5531985592,
    name: 'Wattenwil - Heimenried',
    url: 'http://braetlistellen.ch/wattenwil-heimenried/',
  },
  {
    x: 2602905.386378301,
    y: 1179091.896568547,
    name: 'Wattenwil - Stafelalp',
    url: 'http://braetlistellen.ch/wattenwil-stafelalp/',
  },
  {
    x: 2608810.3131045336,
    y: 1222809.4711457607,
    name: 'Wiler - Spiel- und Begegnungsplatz',
    url: 'https://braetlistellen.ch/wiler-begegnungsplatz/',
  },
  {
    x: 2588540.741418697,
    y: 1201867.1681183768,
    name: 'Wohlen - \u00c4bnitacher',
    url: 'http://braetlistellen.ch/wohlen-aebnitacher/',
  },
  {
    x: 2589890.0538822263,
    y: 1201653.932231628,
    name: 'Wohlen - Burisey',
    url: 'http://braetlistellen.ch/wohlen-burisey/',
  },
  {
    x: 2593419.4400296253,
    y: 1202008.7030233527,
    name: 'Wohlen - Kirchgasse',
    url: 'http://braetlistellen.ch/wohlen-kirchgasse/',
  },
  {
    x: 2593922.1368226497,
    y: 1201765.1435346985,
    name: 'Wohlen - Wohleibr\u00fccke',
    url: 'http://braetlistellen.ch/wohlen-wohleibruecke/',
  },
  {
    x: 2608011.7617635005,
    y: 1195600.5101066185,
    name: 'Worb - Eichholz',
    url: 'http://braetlistellen.ch/worb-eichholz/',
  },
  {
    x: 2611810.223586514,
    y: 1198461.513176999,
    name: 'Worb - Erliwald',
    url: 'http://braetlistellen.ch/worb-erliwald/',
  },
  {
    x: 2610894.1264361795,
    y: 1198075.7989342138,
    name: 'Worb - Lehnr\u00fctti',
    url: 'http://braetlistellen.ch/worb-lehnruetti/',
  },
  {
    x: 2606558.3914559484,
    y: 1197953.785995114,
    name: 'Worb - Robi R\u00fcfenacht',
    url: 'http://braetlistellen.ch/worb-robi-ruefenacht/',
  },
  {
    x: 2608883.718534059,
    y: 1196237.1815427132,
    name: 'Worb - Vielbringen',
    url: 'http://braetlistellen.ch/worb-vielbringen/',
  },
  {
    x: 2609073.9448106023,
    y: 1196628.5622373258,
    name: 'Worb - Wislen',
    url: 'http://braetlistellen.ch/worb-wislen/',
  },
  {
    x: 2601351.036962421,
    y: 1205752.053590841,
    name: 'Zollikofen - Allmend',
    url: 'https://braetlistellen.ch/zollikofen-allmend/',
  },
  {
    x: 2601787.5101662357,
    y: 1205991.2937704606,
    name: 'Zollikofen - Bernstrasse',
    url: 'https://braetlistellen.ch/zollikofen-bernstrasse/',
  },
  {
    x: 2602315.086118205,
    y: 1204724.4445637455,
    name: 'Zollikofen - Meielenwald',
    url: 'https://braetlistellen.ch/zollikofen-meielenwald/',
  },
];
